import { AnyAction } from "redux";
import { ThunkAction } from "redux-thunk";
import { action } from "typesafe-actions";
import axios, { CancelTokenSource } from "axios";
import { api } from "../../api/api";

import { IStoreState } from "../initialStoreState";
import { showMessage } from "../messages/messagesActions";
import { IActionItem } from "./actionItem.types";
import { ISearchQueryParams } from "../store.types";
import { getSearchQueryFromParams } from "../store.utils";

export const FETCH_ACTION_ITEMS_LIST_PROGRESS =
  "FETCH_ACTION_ITEMS_LIST_PROGRESS";
export const FETCH_ACTION_ITEMS_LIST_SUCCESS =
  "FETCH_ACTION_ITEMS_LIST_SUCCESS";
export const FETCH_ACTION_ITEMS_LIST_FAILED = "FETCH_ACTION_ITEMS_LIST_FAILED";

export const fetchActionItemsListProgress = () =>
  action(FETCH_ACTION_ITEMS_LIST_PROGRESS);
export const fetchActionItemsListSuccess = (
  list: IActionItem[],
  totalRecords: number,
) => action(FETCH_ACTION_ITEMS_LIST_SUCCESS, { list, totalRecords });
export const fetchActionItemsListFailed = () =>
  action(FETCH_ACTION_ITEMS_LIST_FAILED);

let cancelToken: CancelTokenSource | null = null;

export const fetchActionItemsListAsync =
  (
    params: ISearchQueryParams,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
      try {
        if (cancelToken) {
          cancelToken.cancel("Operation canceled due to a new request.");
        }
        cancelToken = axios.CancelToken.source();

        dispatch(fetchActionItemsListProgress());

        const query = getSearchQueryFromParams(params);
        const res = await api.get(`/conversation/get-action-item${query}`, {
          cancelToken: cancelToken.token,
        });
        const data: IActionItem[] = res.data.data || [];
        const totalRecords = res.data.totalRecords || 0;

        dispatch(fetchActionItemsListSuccess(data, totalRecords));
      } catch (err: any) {
        if (axios.isCancel(err)) {
          console.log("Previous request canceled", err.message);
        } else {
          dispatch(fetchActionItemsListFailed());
          dispatch(
            showMessage({
              type: "error",
              message:
                err.response?.data?.message || "Failed to fetch action items",
              displayAs: "snackbar",
            }),
          );
        }
      }
    };

export const FETCH_ACTION_ITEM_PROGRESS = "FETCH_ACTION_ITEM_PROGRESS";
export const FETCH_ACTION_ITEM_SUCCESS = "FETCH_ACTION_ITEM_SUCCESS";
export const FETCH_ACTION_ITEM_FAILED = "FETCH_ACTION_ITEM_FAILED";

export const fetchActionItemProgress = () => action(FETCH_ACTION_ITEM_PROGRESS);
export const fetchActionItemSuccess = (actionItem: IActionItem) =>
  action(FETCH_ACTION_ITEM_SUCCESS, { actionItem });
export const fetchActionItemFailed = (errorMessage: string) =>
  action(FETCH_ACTION_ITEM_FAILED, { errorMessage });

export const fetchActionItemAsync =
  (actionItemId: string): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
      try {
        dispatch(fetchActionItemProgress());
        const res = await api.get(
          `/conversation/get-action-item?action_item_uuid=${actionItemId}`,
        );
        const data = res.data.data;
        if (data && data.length > 0) {
          dispatch(fetchActionItemSuccess(data[0]));
        } else {
          dispatch(
            fetchActionItemFailed(
              "Unfortunately, there are no records available at the moment.",
            ),
          );
        }
      } catch (err: any) {
        dispatch(fetchActionItemFailed("Something went wrong!"));
        dispatch(
          showMessage({
            type: "error",
            message: err.response?.data?.message || "Failed to fetch action item",
            displayAs: "snackbar",
          }),
        );
      }
    };

//         export const upsertLeadAsync =
//   (
//     existingLead: ,
//     initialLead: ILead,

//     isUpdate: boolean,
//     isopportunity: boolean,
//     onCallBack: (isSuccess?: boolean, data?: ILead) => void
//   ): ThunkAction<void, IStoreState, {}, AnyAction> =>
//   async (dispatch, getState) => {
//     try {
//       const {
//         create_ts,
//         insert_ts,
//         modified_by_name,
//         modified_by_uuid,
//         created_by_name,
//         created_by_uuid,
//         designation,
//         whatsapp_status,
//         // handled_by_employee,
//         // handled_by_employee_uuid,

//         ...rest
//       } = existingLead;

//       const res = await makeApiCall(
//         {
//           url: endPoints.leads.upsertLead,
//           method: "POST",
//           automation: {
//             primaryFieldName: "lead_id",
//             isUpdate: isUpdate,
//           },
//         },
//         initialLead,
//         rest
//       );
//       dispatch(
//         showMessage({
//           type: "success",
//           message: "Lead is saved successfully",
//           displayAs: "snackbar",
//         })
//       );
//       const data = res.data.data;
//       onCallBack(true, data);
//     } catch (err: any) {
//       onCallBack(false);

//       dispatch(
//         showMessage({
//           type: "error",
//           message: err.response.data.message,
//           displayAs: "snackbar",
//         })
//       );
//     }
//   };

export const upsertActionItemAsync =
  (
    data: IActionItem,
    onCallBack: (isSuccess?: boolean) => void,
  ): ThunkAction<void, IStoreState, {}, AnyAction> =>
    async (dispatch) => {
      try {
        const res = await api.post(`/conversation/upsert-action-item`, data);
        dispatch(
          showMessage({
            type: "success",
            message: "Action item saved successfully",
            displayAs: "snackbar",
          }),
        );
        onCallBack(true);
      } catch (err: any) {
        dispatch(
          showMessage({
            type: "error",
            message: err.response?.data?.message || "Failed to save action item",
            displayAs: "snackbar",
          }),
        );
        onCallBack(false);
      }
    };

export const CLEAR_ACTION_ITEM_STATE = "CLEAR_ACTION_ITEM_STATE";
export const CLEAR_ACTION_ITEM = "CLEAR_ACTION_ITEM";

export const clearActionItemState = () => action(CLEAR_ACTION_ITEM_STATE);
export const clearActionItem = () => action(CLEAR_ACTION_ITEM);
